import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import IconMail from '../../assests/header/icon-mail.png'
import IconPhone from '../../assests/header/icon-phone.png'
import classes from './Support.module.css'
import { generalApi } from '../../utils'
import Message from "../UI/Message";
import { throwApiError } from "../lms-shared/store/error-handling-actions";
import closeIcon from '../../assests/header/close.png';
import { onKeyDown } from '../../service';

const Support = ({ setShowSupport }) => {
    const texts = useSelector(state => state.translate.texts);
    const uiData = useSelector((state) => state.general.uiData);
    const { register, handleSubmit, watch, formState: { errors }, reset } = useForm();
    const [message, setMessage] = useState(null)
    const dispatch = useDispatch();

    function sendSupport() {
        const data = {
            userName: watch("fullName"),
            userPhone: watch("tel"),
            userAddress: watch("mail"),
            subject: watch("subject"),
            body: watch("InputContent")
        }
        generalApi.generalSupportRequestPost({ supportRequestInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.supportPostError, error: error, statusCode: response?.statusCode, message: "generalSupportRequestPost " + error.message, level: 2, component: "Support", line: 28 }))
            }
            else {
                setMessage(<Message color={"green"} text={texts.supportPostSuccess} close={setMessage}></Message>)
                reset();
            }
        })
    }



    return (
        <div className={classes.SupportContainer}>
            {message}
            <div className={classes.Header}>
                <h2>{texts.support}</h2>
                <img src={closeIcon} alt="close" onClick={() => setShowSupport(false)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowSupport(false))} />
            </div>
            <p className={classes.Title}>{texts.skillsSupportCenter}</p>
            <form className={classes.FormContainer} onSubmit={handleSubmit(sendSupport)}>
                <input className={classes.Input} placeholder={texts.fullName}  {...register('fullName', { required: true })} />
                <input className={classes.Input} placeholder={texts.tel} {...register('tel', {
                    required: true,
                    pattern: {
                        value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im,
                        message: true
                    }
                })} />
                {errors.tel?.message && <p className={classes.ErrorInput}>{texts.ErrorInvalidPhone}</p>}
                <input className={classes.Input} placeholder={texts.mail} {...register('mail', {
                    required: true,
                    pattern: {
                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: true,
                    }
                })} />
                {errors.mail?.message && <p className={classes.ErrorInput}>{texts.ErrorInvalidEmail}</p>}
                <input className={classes.Input} placeholder={texts.subject} {...register('subject', { required: true })} />
                <textarea className={`${classes.Input}  ${classes.InputContent}`} placeholder={texts.InputContent} {...register('InputContent', { required: true })} />
                {(errors.fullName || (errors.tel && watch("tel") === '') || (errors.mail && watch("mail") === '') || errors.subject || errors.InputContent) && <p className={classes.ErrorInput}>{texts.ErrorRequiredFields}</p>}
                <input type="submit" className={classes.BtnFillForm} value={texts.send} />
            </form>
            <p className={classes.MailAndPhoneContainer}>{texts.questionsTechnicalIssuesOrMalfunctions}</p>
            <p className={classes.Mail}><img src={IconMail} alt="mail" /> <a className={classes.MailText} href='mailto:skillzSupport@taldor.co.il'>Support@skillz-edu.org</a></p>
            <div className={`${classes.goodToKnowContent} ${classes.Phone}`}><img src={IconPhone} alt="phone" /> <div>*6552 → 1 → 3</div></div>
            {/* <p className={classes.goodToKnowContent}>{texts.supportFillForm}</p>
            <button className={classes.BtnFillForm}>
                <a className={classes.ToFormLink} href={uiData.supportFillFormUrl} target="_blank">{texts.toForm}</a>
            </button> */}
            <p className={classes.goodToKnowTitle}>{texts.goodToKnow}</p>
            <p className={classes.goodToKnowContent}>{texts.supportGoodToKnowContent}</p>
            {uiData && <p className={classes.goodToKnowContent}><a href={uiData.MOENewPassword} className={classes.Link}>{texts.clickHere}</a> {texts.supportEnterWithSMS}</p>}
            {uiData && <p className={classes.goodToKnowContent}>{texts.supportNewPassword}<a href={uiData.MOENewPassword} className={classes.Link}>{texts.clickHere}</a></p>}
            <p className={classes.goodToKnowContent}>{texts.supportPasswordCenter}</p>
            <div className={`${classes.goodToKnowContent} ${classes.Phone}`}><img src={IconPhone} alt="phone" /> <div>*6552</div></div>
            <p className={classes.goodToKnowContent}>{texts.supportTelephoneAnswer}</p>
        </div >
    )

}

export default Support;